import * as React from 'react';
import { Helmet } from 'react-helmet';

// google-optimize検証ページに設置する
const OptimizeTag: React.FC = () => {
  return (
    <Helmet>
      <script
        src={`https://www.googleoptimize.com/optimize.js?id=${
          import.meta.env.VITE_OPTIMIZE_ID
        }`}
      />
    </Helmet>
  );
};

export default OptimizeTag;
